var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-cascader',{attrs:{"placeholder":"岗位地点","options":_vm.options,"value":_vm.value,"show-all-levels":true,"props":{
    label: 're_name',
    value: 're_name',
    emitPath: false,
    checkStrictly: true,
  },"filterable":""},on:{"change":_vm.handleChange}})}
var staticRenderFns = []

export { render, staticRenderFns }